import { postTokens, deleteRevorkToken } from '../../services/api/auth.api';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_SUCCESS, LOGOUT_REQUEST, LOGOUT_FAILURE, CLEAR_LOGIN_ERROR } from '../types';
import { transformError } from '../../transforms/error';
import { transformTokens } from '../../transforms/auth';
import { getJTI } from '../../helpers/jwt';

// set tokens state by get tokens from local storage
const initialTokens = {
	access_token: localStorage.getItem('access_token'),
	refresh_token: localStorage.getItem('refresh_token'),
};

// set `isLoggedIn` state by get tokens from local storage
const initialIsLoggedIn = !!initialTokens.access_token;

export default {
	namespaced: true,

	state: {
		isLoading: false,
		isLoggingOut: false,
		error: null,
		me: null,
		isLoggedIn: initialIsLoggedIn,
		isLoginError: false,
		tokens: transformTokens(initialTokens),
	},

	mutations: {
		// login
		[LOGIN_REQUEST](state) {
			state.isLoading = true;
			state.isLoginError = false;
			state.error = null;
			state.tokens = {};
		},
		[LOGIN_SUCCESS](state, data) {
			state.isLoading = false;
			state.isLoggedIn = true;
			state.tokens = transformTokens(data);

			// set tokens to localstorage
			localStorage.setItem('access_token', state.tokens.accessToken);
			localStorage.setItem('refresh_token', state.tokens.accessToken);
		},
		[LOGIN_FAILURE](state, error) {
			state.error = transformError(error);
			state.isLoginError = true;
			state.isLoading = false;
		},

		// logout
		[LOGOUT_REQUEST](state) {
			state.isLoggingOut = true;
		},
		[LOGOUT_SUCCESS](state) {
			// clear tokens in state
			state.tokens = {};
			state.isLoggedIn = false;
			state.isLoggingOut = false;

			// clear tokens in local storage
			localStorage.removeItem('access_token');
			localStorage.removeItem('refresh_token');
		},
		[LOGOUT_FAILURE](state, error) {
			state.error = transformError(error);
			state.isLoggingOut = false;

			// clear tokens in local storage
			localStorage.removeItem('access_token');
			localStorage.removeItem('refresh_token');
		},

		// clear error in state
		[CLEAR_LOGIN_ERROR](state) {
			state.isLoginError = false;
		},
	},

	actions: {
		async login({ commit }, { username, password }) {
			try {
				commit(LOGIN_REQUEST);
				const { data } = await postTokens({ username, password });
				commit(LOGIN_SUCCESS, data);
			} catch (error) {
				commit(LOGIN_FAILURE, error);
			}
		},
		async logout({ commit }) {
			try {
				// get jti from local storage, then decode access token by jwt
				const jti = getJTI(localStorage.getItem('access_token'));

				commit(LOGOUT_REQUEST);
				await deleteRevorkToken({ jti });
				commit(LOGOUT_SUCCESS);
			} catch (error) {
				commit(LOGOUT_FAILURE, error);
			}
		},
		clearLoginError({ commit }) {
			commit(CLEAR_LOGIN_ERROR);
		},
	},
};